import styled from 'styled-components';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import FilterContainer from '../../../search/components/filters/FilterContainer';
import MinMaxInputContainer from '../../../search/components/search-filters/min-max-view/MinMaxInputContainer';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

const PriceRangeFilter = () => {
  const { t } = useTranslation(['map', 'search']);

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { filterOptions, searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;

  return (
    <Container>
      {isMobile && (
        <div className="header">
          <span className="description">{t('enter_min_max_budget')}</span>
        </div>
      )}

      <FilterContainer
        displayedValues={[
          {
            name: SearchFiltersTypes.MIN_PRICE,
            value: searchFiltersState.searchFilters.min_price,
            preValue: t('min', { ns: 'search' }),
            postValue: '',
            filterAction:
              SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE
          },
          {
            name: SearchFiltersTypes.MAX_PRICE,
            value: searchFiltersState.searchFilters.max_price,
            preValue: t('max', { ns: 'search' }),
            postValue: '',
            filterAction:
              SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE
          }
        ]}
      >
        <MinMaxInputContainer
          maxFilterType={SearchFiltersTypes.MAX_PRICE}
          minFilterType={SearchFiltersTypes.MIN_PRICE}
          minList={filterOptions.min_price}
          maxList={filterOptions.max_price}
          min={parseInt(filterOptions.min_price[0].value.toString())}
        />
      </FilterContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      font-size: 18px;
      font-family: materialSemiBold;
      color: #282828;
    }

    .description {
      font-size: 14px;
      font-family: materialRegular;
      color: #475467;
    }
  }
`;

export default PriceRangeFilter;
